import React, { useEffect, useState } from 'react';
import { Box, Stack, Typography, Skeleton } from '@mui/material';
import { collection, query, where, getCountFromServer, doc, getDoc } from 'firebase/firestore';
import { db } from '../../../../firebase.config';
import { UserAuth } from '../../../../context/AuthContext';
import Iconify from '../../../../components/Iconify';
import LucideIcon from '../../../../components/LucideIcon';

const ContactStats = () => {
  const { user } = UserAuth();
  const [loading, setLoading] = useState(true);
  const [totalContacts, setTotalContacts] = useState(0);
  const [newsletterContacts, setNewsletterContacts] = useState(0);

  const fetchStats = async () => {
    try {
      if (!user) return;
      setLoading(true);

      const orgSnap = await getDoc(doc(db, 'organisateurs', user.uid));
      const orgId = orgSnap.data()?.idOrg;

      const basePath = `organisations/${orgId}/crm/${orgId}/contacts`;

      const allQuery = query(collection(db, basePath));
      const newsletterQuery = query(collection(db, basePath), where('newsletter', '==', true));

      const [allCountSnap, newsletterSnap] = await Promise.all([
        getCountFromServer(allQuery),
        getCountFromServer(newsletterQuery),
      ]);

      setTotalContacts(allCountSnap.data().count || 0);
      setNewsletterContacts(newsletterSnap.data().count || 0);

    } catch (e) {
      console.error('Erreur contacts:', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, [user]);

  return (
    <Box sx={{ p: 2, bgcolor: '#D2C2FF', borderRadius: '10px', boxShadow: 5, height: '100%', }}>
      <Stack spacing={3}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <LucideIcon name='Contact'/>
          <Typography variant="body2">Contacts</Typography>
        </Stack>

        {!loading ? (
          <Stack direction="row" spacing={2} alignItems="baseline">
            <Stack direction="column" alignItems="baseline">
              <Typography variant="h5">{totalContacts}</Typography>
              <Typography variant="body2">total</Typography>

            </Stack>
            <Stack direction="column" alignItems="baseline">

              <Typography variant="h5">{newsletterContacts}</Typography>
              <Typography variant="body2">newsletter</Typography>
            </Stack>
          </Stack>
        ) : (
          <Stack direction="row" spacing={1}>
            <Skeleton width={50} height={30} />
            <Skeleton width={50} height={30} />
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default ContactStats;
